import React from "react";

import { useTranslation } from "react-i18next";

import SwitchOnOff from "../../../components/common/tools/SwitchOnOff";
import ConditionalRender from "../../../components/conditionalRender/ConditionalRender";

import type { JSX } from "react";

import type {
  CarouselParams,
  ConditionRender,
  FAQComponent,
  HighlightParams,
  MosaicParams,
  ShortcutComponent,
} from "../../../api/ProjectAPI.types";

interface ConditionalRenderEditorProps {
  componentParams:
    | HighlightParams
    | FAQComponent["params"]
    | ShortcutComponent["params"]
    | MosaicParams
    | CarouselParams;
  onChangeConditionsToggle: (checked: boolean) => void;
  onChangeConditions: (conditions: ConditionRender[]) => void;
}
function ConditionalRenderEditor({
  componentParams,
  onChangeConditionsToggle,
  onChangeConditions,
}: ConditionalRenderEditorProps): JSX.Element {
  const { t } = useTranslation("editor-platform");
  return (
    <React.Fragment>
      <div className="py-[0.625rem] text-[0.9375rem] font-semibold">
        {t("conditionalRender")}
      </div>
      <div className="m-[0.3125rem] flex items-center gap-[0.625rem]">
        <SwitchOnOff
          checked={componentParams?.has_conditions ?? false}
          name="hasConditions"
          onChange={onChangeConditionsToggle}
          size="sm"
        />
        <div>{t("activeConditions")}</div>
      </div>
      {componentParams?.has_conditions ? (
        <div className="m-[0.3125rem] flex items-center gap-[0.625rem]">
          <ConditionalRender
            conditions={componentParams?.conditional_render}
            onChange={onChangeConditions}
          />
        </div>
      ) : null}
    </React.Fragment>
  );
}

export default ConditionalRenderEditor;
